const INIT_STATE = {
    init: "value"
}


export default INIT_STATE;